import React, { useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { ChevronUp } from 'feather-icons-react/build/IconComponents';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { PlusCircle } from 'react-feather';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import AddUsers from '../../core/modals/usermanagement/addusers';
import { useToast } from '../../Toaster/ToastContext';
import Loader from '../loader/loader';
import { apiClient } from '../../services/apiClient';

const Users = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const hasFetched = useRef(false);
    const [currentUser, setCurrentUser] = useState(null);

    const fetchUsers = async (force = false) => {
        const userType = localStorage.getItem('user_type');
        const skipBusinessId = userType === 'owner';
        if (hasFetched.current && !force) return;
        setLoading(true);
        try {
            const data = await apiClient.post('/paginate-business-user', {
                    pageIndex: 0,
                    pageSize: 50,
                    previousPageIndex: 0,
                },
                skipBusinessId // Skip business ID if user is owner
            );
            // const data = await response.json();
            if (data.success) {
                setUsers(data.data);
                setFilteredUsers(data.data);
            } else {
                setUsers([]);
                setFilteredUsers([]);
            }
        } catch (error) {
            showToast(error.message || 'Failed to fetch users', 'error', 'Business Users');
        } finally {
            setLoading(false);
            hasFetched.current = true;
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setFilteredUsers(
            users.filter((user) =>
                user.name.toLowerCase().includes(term) ||
                user.status.toLowerCase().includes(term)
            )
        );
    };

    const handleAddUser = () => {
        setCurrentUser(null);
    };

    const handleEditUser = (user) => {
        setCurrentUser(user);
    };

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    )

    const columns = [

        {
            title: "User Name",
            dataIndex: "name",
            render: (text, record) => (
                <span className="userimgname">
                    <ImageWithBasePath alt={record.name || "User Logo"} src={record.user_image} className="prod_image" />
                    <div>
                    <Link to="#">{text}</Link>
                    </div>
                </span>
            ),
            sorter: (a, b) => a.name.length - b.name.length,
        },
        {
            title: "Business",
            dataIndex: "business_name",
            sorter: (a, b) => (a.business_name || 'N/A').length - (b.business_name || 'N/A').length,
        },
        {
            title: "Branch",
            dataIndex: "branch",
            render: (branch) => branch ? branch.name : 'N/A',
            sorter: (a, b) => (a.branch?.name || 'N/A').length - (b.branch?.name || 'N/A').length,        },
        {
            title: "Phone",
            dataIndex: "phone",
            sorter: (a, b) => a.phone.length - b.phone.length,
        },
        {
            title: "Email",
            dataIndex: "email",
            sorter: (a, b) => a.email.length - b.email.length,
        },
        // {
        //     title: "Role",
        //     dataIndex: "role",
        //     sorter: (a, b) => a.role.length - b.role.length,
        // },
        {
            title: "Created On",
            dataIndex: "created_at",
            sorter: (a, b) => a.created_at.length - b.created_at.length,
            render: (text) => {
                const date = new Date(text);
                return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).split('/').join('-');
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (
                <span className={`badge ${text === 'active' ? 'badge-linesuccess' : 'badge-linedanger'}`}>
                    {text === 'active' ? 'Active' : 'Inactive'}
                </span>
            ),
            sorter: (a, b) => a.status.length - b.status.length,
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (_, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        {/* <Link className="me-2 p-2" to="#">
                            <i data-feather="eye" className="feather feather-eye action-eye"></i>
                        </Link> */}
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-units" onClick={() => handleEditUser(record)}>
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        <Link className="confirm-text p-2" to="#"  >
                            <i data-feather="trash-2" className="feather-trash-2" onClick={() => showConfirmationAlert(record)}></i>
                        </Link>
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    const data = await apiClient.post('/delete-business-user', { id: record.id });
                    // const data = await response.json();
                    if (data.success) {
                        showToast('User deleted successfully', 'success', 'Business User Operation!');
                        fetchUsers(true);
                    } else {
                        showToast(data.message || 'Failed to delete user', 'error', 'Business User Operation!');
                    }
                } catch (error) {
                    showToast(error.message || 'Failed to delete user', 'error', 'Business User Operation!');
                } finally {
                    setLoading(false);
                }
            } else {
                MySwal.close();
            }

        });
    };
    return (
        <div>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>User List</h4>
                                <h6>Manage Your Users</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className="page-btn">
                            <a
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-units"
                                onClick={handleAddUser}
                            >
                                <PlusCircle className="me-2" />
                                Add New User
                            </a>
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            onChange={handleSearch}
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={filteredUsers}
                                    rowKey={(record) => record.id}
                                    rowSelection={null}
                                />
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
        <AddUsers 
            user={currentUser}
                onSave={() => {
                    hasFetched.current = false;
                    fetchUsers();
                }}
        />
        </div>
    )
}

export default Users
